export const ENTRY_PERMISSION = 'settings';

export const ENTRY_LINK = {
  path: '/tasking-dashboard',
  text: 'Tasking',
  module: 'tasking-dashboard',
  component: 'Dashboard',
  permission: ENTRY_PERMISSION,
};
